import Text from 'core-system/Text'
import React from 'react'
import styled from 'styled-components'
import WorksitesFilter from './WorksitesFilter'
import { ActiveLayer } from '../types'

const Container = styled.div`
  width: 100%;
  height: 4rem;
  display: flex;
  border-bottom: 1px solid ${(props) => props.theme.palette.grey.grey300};
  margin-bottom: 1rem;
`

const LayersContainer = styled.div`
  flex: 1;
  width: 100%;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

const Layers = styled.div`
  display: flex;
  padding: 1rem 2rem;
`

const Layer = styled.div<{ isActive: boolean }>`
  padding: 0.375rem 0.625rem;
  background-color: ${(props) =>
    props.isActive && props.theme.palette.secondary.purple600};
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  margin-right: 1rem;
  cursor: pointer;
  color: ${(props) =>
    props.isActive
      ? props.theme.palette.white
      : props.theme.palette.text.primary};

  &:hover {
    background-color: ${(props) =>
      props.isActive
        ? props.theme.palette.secondary.purple400
        : props.theme.palette.secondary.purple400};
  }
`

interface ControlPanelProps {
  activeLayer: ActiveLayer
  updateActiveLayer: (layer: ActiveLayer) => void
  selectedWorksite: string | null
  onWorksiteChange: (worksiteId: string | null) => void
  dropdownItems: { id: string; text: string }[]
}

const LayerComponent = (props: {
  isActive: boolean
  onClick: () => void
  key: string
  name: string
}) => {
  return (
    <Layer key={props.key} isActive={props.isActive} onClick={props.onClick}>
      <Text variant='action4' textColor='unset'>
        {props.name}
      </Text>
    </Layer>
  )
}

const ControlPanel = React.memo((props: ControlPanelProps) => {
  const {
    activeLayer,
    updateActiveLayer,
    selectedWorksite,
    onWorksiteChange,
    dropdownItems,
  } = props

  return (
    <Container>
      <WorksitesFilter
        selectedWorksite={selectedWorksite}
        onWorksiteChange={onWorksiteChange}
        dropdownItems={dropdownItems}
      />
      <LayersContainer>
        <Layers>
          <LayerComponent
            key='commuteModes'
            isActive={activeLayer === 'commuteModes'}
            onClick={() => updateActiveLayer('commuteModes')}
            name='Commute Modes'
          />
          <LayerComponent
            key='agony'
            isActive={activeLayer === 'agony'}
            onClick={() => updateActiveLayer('agony')}
            name='Agony'
          />
        </Layers>
      </LayersContainer>
    </Container>
  )
})

export default ControlPanel
